import React from 'react';
import CompaniesList from 'pages/Resales/CompaniesList';
import RankingList from 'pages/Resales/List';
import { Container, Row, Card, Tabs, Tab, Col, Button } from 'react-bootstrap';
import { Add, BusinessOutlined } from '@material-ui/icons';
import { useProfile, useUser } from 'models';
import { useHistory } from 'react-router';
import Can from 'components/Can';

export default function(){
	const history = useHistory()
	const user = useUser()
  const profile = useProfile()

	const minWidth = 940;
	const isMobile = window.innerWidth <= minWidth;

	let defaultActiveKey = "companies";

	const items = [
		{ eventKey: 'companies', title: "Empresas", component: () => <CompaniesList className="col-12" /> }
	]

	if (profile.havePermission('ranking.show')) {
		items.unshift({
			eventKey: 'ranking',
			title: "Ranking",
			component: () => <RankingList />
		})
		defaultActiveKey = "ranking"
	}

	return (
		<Container fluid>
			<Row className="mt-4">
				<BusinessOutlined className="icon-title" />
				<h5 className="title-dashboard">Empresas</h5>
			</Row>
			<Row>				
				<Card.Body className={
					"card-dashboard shadow bg-white rounded m-2 col-12" +
					(!isMobile ? 'p-5' : 'p-0')
				}>
					<Row>
						<Can do="resale.create" on="App">
							<Col md="12" className='mb-3'>
								<Button className="btn-add" onClick={() => history.push('/company/create')}>
									<Add /> Cadastrar Empresa
								</Button>
							</Col>
						</Can>
						<Col md="12">
							<Tabs defaultActiveKey={defaultActiveKey} className="col-12 mb-3" id="CompaniesList">
								{items.map(item => (
									<Tab eventKey={item.eventKey} className="col-12" title={item.title}>
										{item.component()}
									</Tab>
								))}
							</Tabs>
						</Col>
					</Row>					
				</Card.Body>
			</Row>
		</Container>
	);

};
